import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { Link, useNavigate } from "react-router-dom";
import { getAllSuppliers } from "../../reduxSaga/actions";

import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import { Snackbar, TextField } from "@material-ui/core";
import PurchaseService from "../../services/PurchaseOrder";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import { Alert } from "@material-ui/lab";

import UploadPdfFile from "../../ui/UploadPdfFile";
import ProductService from "../../services/ProductService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import DevisNonConfirme from "./Table/DevisNonConfirme";
import DevisRelatedBDC from "./Table/DevisRelatedBDC";
import DevisArchived from "./Table/DevisArchived";
import withLoader from "../../components/layouts/WithLoader";
const SupplierQuotations = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const suppliers = useSelector((state) => state.staff.suppliers.Societe);

  const [oldWarehouseData, setOldWarehouseData] = useState();
  // const [onAddSubFamily, setOnAddSubFamily] = useState(false);
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Tous");
  const [allSuppliers, setAllSuppliers] = useState([
    { value: 0, label: "Tous" },
  ]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inConfirmedDevis, setInConfirmedDevis] = useState([]);
  const [devisRelatedToBC, setDevisRelatedToBC] = useState([]);
  const [archivedDevis, setArchivedDevis] = useState([]);
  const [devisRelatedToInvoice, setDevisRelatedToInvoice] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [chargedInfo, setChargedInfo] = useState(false);

  const [devisUploadInformation, setDevisUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedDevis: inConfirmedDevis,
  });

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }

    dispatch(getAllSuppliers());
    startLoading();
    let pendingRequests = 2;
    const requestDone = () => {
      pendingRequests -= 1;
      if (pendingRequests === 0) stopLoading();
    };
    ProductService.getDevisOfLastMonth(getCurrentUserId(), 0)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          response.data.success.forEach((element) => {
            if (element.state === 0) {
              setInConfirmedDevis((previoustate) => [...previoustate, element]);
            } else if (element.state === 1) {
              console.log(element);
              setDevisRelatedToBC((previoustate) => [...previoustate, element]);
            } else if (element.state === 2) {
              setDevisRelatedToInvoice((previoustate) => [
                ...previoustate,
                element,
              ]);
            }
          });
          setChargedInfo(true);
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      }).finally(requestDone);

    PurchaseService.getDevisOfLastMonth(1)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setArchivedDevis(response.data.success);
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      }).finally(requestDone);
  }, []);

  useEffect(() => {
    suppliers &&
      suppliers.map((element, i) => {
        let exist = false;
        if (allSuppliers.length !== 0) {
          for (let index = 0; index < allSuppliers.length; index++) {
            if (allSuppliers[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllSuppliers((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [suppliers]);

  useEffect(() => {
    if (dateBegin === ":59") {
      setDateBegin("any");
    }
    if (dateEnd === ":59") {
      setDateEnd("any");
    }
  }, [dateBegin, dateEnd]);

  const onAddDevisHandler = () => {
    navigate(`/addQuotation`);
  };

  const onArchiveHandler = (refDocument, isDeleted) => {
    PurchaseService.deleteAndRestoreDevis(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          if (isDeleted === 1) {
            let newState = inConfirmedDevis.filter(
              (item) => item.reference !== refDocument
            );
            setInConfirmedDevis(newState);

            let new_array = add_items_to_array_at_position(archivedDevis, 0, [
              response.data.success,
            ]);

            setArchivedDevis(new_array);
          } else if (isDeleted === 0) {
            let newState = archivedDevis.filter(
              (item) => item.reference !== refDocument
            );
            setArchivedDevis(newState);

            let new_array = add_items_to_array_at_position(
              inConfirmedDevis,
              0,
              [response.data.success]
            );
            setInConfirmedDevis(new_array);
          }
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const onViewProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "devis");

    navigate("/getDocumentByRef");
  };

  const onChangeSelectedSupplier = (selectedOptionn) => {
    setSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  function add_items_to_array_at_position(array, index, new_items) {
    return [...array.slice(0, index), ...new_items, ...array.slice(index)];
  }

  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value already includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // If time exists, append ":00" to set seconds to 00
      : selectedValue + "T00:00:00"; // If it's a date-only input, append "T00:00:00" for the first second of the day

    setDateBegin(updatedValue);
  };


  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value already includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // If time exists, append ":59" to set seconds to 59
      : selectedValue + "T23:59:59"; // If it's a date-only input, append "T23:59:59" for the last second of the day

    setDateEnd(updatedValue);
  };

  const onGetDevisByFiltersHandler = () => {
    startLoading();
    let pendingFilters = 4;
    const filterDone = () => {
      pendingFilters -= 1;
      if (pendingFilters === 0) stopLoading();
    };
    for (let state = -1; state < 3; state++) {
      PurchaseService.getDevisByFilters(supplierId, state, dateBegin, dateEnd)
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            if (state === -1) {
              setArchivedDevis(response.data.success);
            } else if (state === 0) {
              setInConfirmedDevis(response.data.success);
            } else if (state === 1) {
              console.log("setDevisRelatedToBC ", response.data.success);
              setDevisRelatedToBC(response.data.success);
            } else if (state === 2) {
              setDevisRelatedToInvoice(response.data.success);
            }
          } else if (Object.keys(response.data)[0] === "empty") {
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + error);
        })
        .finally(filterDone);
    }
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  // const onUploadFileHandler = (state, reference, index, isDeleted) => {
  //   if (isDeleted === 0) {
  //     if (state === 0) {
  //       setDevisUploadInformation({
  //         reference: reference,
  //         state: state,
  //         index: index,
  //         devisData: inConfirmedDevis,
  //         isDeleted: 0,
  //       });
  //     } else if (state === 1) {
  //       setDevisUploadInformation({
  //         reference: reference,
  //         state: state,
  //         index: index,
  //         devisData: devisRelatedToBC,
  //         isDeleted: 0,
  //       });
  //     } else if (state === 2) {
  //       setDevisUploadInformation({
  //         reference: reference,
  //         state: state,
  //         index: index,
  //         devisData: devisRelatedToInvoice,
  //         isDeleted: 0,
  //       });
  //     }
  //   } else {
  //     setDevisUploadInformation({
  //       reference: reference,
  //       state: state,
  //       index: index,
  //       devisData: archivedDevis,
  //       isDeleted: 1,
  //     });
  //   }

  //   setOnUploadFile(true);
  // };

  // const onAddTaxHandler = (id) => {
  //   sessionStorage.setItem("idTax", id);
  //   sessionStorage.setItem("typeToTax", "Devis");
  //   navigate("/addTaxAndCharge");
  // };
  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
  const canCreate =
    userRole.includes("ADMIN") || userRole.includes("PURCHASING_MANAGER");

  const kpis = [
    {
      label: "Non confirmés",
      value: inConfirmedDevis.length,
      icon: "fas fa-hourglass-half",
      color: "#f0ad4e",
    },
    {
      label: "Liés à un bon de commande",
      value: devisRelatedToBC.length,
      icon: "fas fa-file-signature",
      color: "#17a2b8",
    },
    {
      label: "Archivés",
      value: archivedDevis.length,
      icon: "fas fa-archive",
      color: "#6c757d",
    },
  ];

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-file-alt mr-2"></i>Les devis d'achat
              </h4>
              <small className="text-muted">
                Par défaut, les devis ajoutés durant le dernier mois
              </small>
            </div>
            {canCreate && (
              <button
                className="btn btn-dark mt-2 mt-sm-0 d-inline-flex align-items-center"
                style={{
                  borderRadius: 8,
                  padding: "8px 18px 8px 10px",
                  fontWeight: 500,
                }}
                onClick={onAddDevisHandler}
              >
                <span
                  className="d-inline-flex align-items-center justify-content-center mr-2"
                  style={{
                    width: 26,
                    height: 26,
                    borderRadius: 6,
                    backgroundColor: "rgba(255,255,255,.18)",
                  }}
                >
                  <i className="fas fa-plus" style={{ fontSize: 12 }} />
                </span>
                Nouveau devis
              </button>
            )}
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row mt-3">
            {kpis.map((k) => (
              <div className="col-md-4" key={k.label}>
                <div
                  className="d-flex align-items-center p-3 mb-3 bg-white"
                  style={{ ...cardStyle, borderLeft: `4px solid ${k.color}` }}
                >
                  <span
                    className="d-flex align-items-center justify-content-center text-white mr-3"
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 8,
                      backgroundColor: k.color,
                    }}
                  >
                    <i className={k.icon}></i>
                  </span>
                  <div>
                    <small
                      className="text-muted text-uppercase d-block"
                      style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                    >
                      {k.label}
                    </small>
                    <span style={{ fontSize: "1.4rem", fontWeight: 700 }}>
                      {k.value}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="card card-outline card-dark" style={cardStyle}>
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-filter mr-2"></i>Filtres
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label style={labelStyle}>Fournisseur</label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={supplierSelectedOption}
                      onChange={onChangeSelectedSupplier}
                      options={allSuppliers}
                      placeholder={supplierSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="quotationDateBegin" style={labelStyle}>
                      Date début
                    </label>
                    <input
                      id="quotationDateBegin"
                      type="date"
                      className="form-control"
                      onChange={onChangeDateBegin}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="quotationDateEnd" style={labelStyle}>
                      Date fin
                    </label>
                    <input
                      id="quotationDateEnd"
                      type="date"
                      className="form-control"
                      onChange={onChangeDateEnd}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <button
                className="btn btn-dark"
                onClick={onGetDevisByFiltersHandler}
              >
                <i className="fas fa-search mr-1"></i>
                Valider le choix
              </button>
            </div>
          </div>

          {chargedInfo && (
            <>
              <DevisNonConfirme listDevis={inConfirmedDevis} />
              <DevisRelatedBDC listDevis={devisRelatedToBC} />
              <DevisArchived listDevis={archivedDevis} />
            </>
          )}
        </div>
      </section>

      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {onUploadFile && (
        <UploadPdfFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedDevis={setInConfirmedDevis}
          setDevisRelatedToBC={setDevisRelatedToBC}
          setDevisRelatedToInvoice={setDevisRelatedToInvoice}
          devisUploadInformation={devisUploadInformation}
          setArchivedDevis={setArchivedDevis}
        />
      )}
    </div>
  );
};
export default withLoader(SupplierQuotations);
